import { create } from 'zustand';

/**
 * Which publishing-pause dialog is open (Task 1.5). One dialog pair for the
 * app (PublishingPauseDialogs), opened from the Calendar, Settings, the
 * Paused pill or an at-risk row through this store.
 */
interface PauseDialogs {
  open: 'pause' | 'resume' | null;
  show: (which: 'pause' | 'resume') => void;
  close: () => void;
}

export const usePauseDialogs = create<PauseDialogs>()((set) => ({
  open: null,
  show: (which) => set({ open: which }),
  close: () => set({ open: null }),
}));
